import type { RoomsParticipantDistribution } from '@/domain/shared/types'
import type { PublicationCode } from '@/scopes/common/domain/models'
import type { FiltersInQuickSearch } from '@/scopes/search/quick-search/domain/types'
import { FiltersSelection, SearchFilters } from '@/scopes/search/search/infrastructure/api/types'

const filterSelections: Record<string, Partial<FiltersInQuickSearch | FiltersSelection<SearchFilters>>> = {
  SZ: { Duration: ['6-10'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'Flight' },
  FS: { Duration: ['8-11'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'Flight' },
  BZ: { Duration: ['8-11'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'Flight' },
  WG: { Duration: ['8-10'], Participants: [{ adults: 4, children: [], babies: [] }], TransportType: 'SelfDrive' },
  KZ: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'Flight' },
  KW: { Duration: ['8-10'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  QZ: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'Flight' },
  QW: { Duration: ['8-8', '9-14'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  FW: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  UW: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  DW: { Duration: ['8-8'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  FZ: { Duration: ['8-9'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'Flight' },
  FH: { Duration: ['8-999'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  BW: { Duration: ['8-10'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'SelfDrive' },
  EZ: { Duration: ['8-11'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'Flight' },
  BE: { Duration: ['8-11'], Participants: [{ adults: 2, children: [], babies: [] }], TransportType: 'Flight' },
}

export function getDefaultQuickSearchSelection(publicationCode: PublicationCode): Partial<FiltersInQuickSearch> {
  return (filterSelections[publicationCode] ?? {}) as Partial<FiltersInQuickSearch>
}

export function getDefaultSearchSelection(publicationCode: PublicationCode): Partial<FiltersSelection<SearchFilters>> {
  return (filterSelections[publicationCode] ?? {}) as Partial<FiltersSelection<SearchFilters>>
}

export function getDefaultSharedFilterSelection(
  publicationCode: PublicationCode,
): { Participants?: RoomsParticipantDistribution, TransportType?: string } {
  const { Participants, TransportType } = filterSelections[publicationCode] ?? {}
  return {
    Participants: Participants as RoomsParticipantDistribution | undefined,
    TransportType: TransportType as string | undefined,
  }
}
